import React, { useSyncExternalStore } from 'react';
import { Button } from './ui/Button';
import { abonniere, aktualisiereJetzt, blendeAus, kartenZustand } from '../neueVersion';
import { darkTheme, lightTheme } from '../constants/verwaltungsThemes';

/** Jede Ansicht merkt sich ihr Schema unter eigenem Schlüssel (CLAUDE.md, Theme) — hell, solange nichts gewählt ist */
const schemaSchluessel = (pfad: string): string => {
  if (pfad.startsWith('/helfer')) return 'helfer_theme';
  if (pfad.startsWith('/public/') || pfad.startsWith('/sanlog/') || pfad === '/les') return 'publicViewTheme';
  if (pfad.startsWith('/structure/')) return 'structure-theme';
  if (pfad.startsWith('/survey/')) return 'survey-theme';
  return 'theme';
};
const istDunkel = (): boolean => {
  try { return localStorage.getItem(schemaSchluessel(window.location.pathname)) === 'dark'; } catch { return false; }
};

/** Die Neuerungen beschreiben die Verwaltung — Helfer-Portal und öffentliche Seiten zeigen die Karte ohne Liste */
const VERWALTUNG = /^\/(events|verwaltung|personen|anmeldungen|abrechnung|planungsrechner|kalkulationen|infoseiten|tools|login)(\/|$)/;

/**
 * Karte „Neue Version bereit“ (Mockup docs/mockups/app-aktualisieren.html, Auswahl 1D). Erscheint nur, wenn die App
 * nicht still neu laden darf, weil gerade etwas offen oder eingetippt ist (Regeln in neueVersion.ts).
 */
const NeueVersionKarte: React.FC = () => {
  const { sichtbar, punkte } = useSyncExternalStore(abonniere, kartenZustand);
  if (!sichtbar) return null;
  const theme = istDunkel() ? darkTheme : lightTheme;
  const liste = VERWALTUNG.test(window.location.pathname) ? punkte : [];
  return (
    <div role="status" aria-live="polite" style={{
      position: 'fixed', left: 12, right: 12, bottom: 'calc(env(safe-area-inset-bottom, 0px) + 12px)', zIndex: 2000,
      maxWidth: 460, margin: '0 auto', background: theme.bgCard, color: theme.text, border: `1px solid ${theme.border}`,
      borderRadius: 'var(--r-l)', boxShadow: '0 10px 30px rgba(15,23,42,0.25)', padding: 14,
      display: 'flex', flexDirection: 'column', gap: 10, fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    }}>
      <b style={{ fontSize: '0.95rem' }}>Neue Version bereit</b>
      {liste.length > 0 && (
        <ul style={{ margin: 0, paddingLeft: 18, color: theme.textMuted, fontSize: '0.84rem', lineHeight: 1.45 }}>
          {liste.map(p => <li key={p}>{p}</li>)}
        </ul>
      )}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <Button variant="secondary" klein theme={theme} onClick={blendeAus} style={{ minHeight: 36 }}>Später</Button>
        <Button klein theme={theme} onClick={aktualisiereJetzt} style={{ minHeight: 36 }}>Aktualisieren</Button>
      </div>
    </div>
  );
};

export default NeueVersionKarte;
